import React from 'react';
import clsx from 'clsx';

import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Checkbox from '@material-ui/core/Checkbox';

import SystemUpdateAltIcon from '@material-ui/icons/SystemUpdateAlt';

import DownloadWarning from './download-warning';
import DownLoadConfirm from './download-confirmation';

const paperElevation = 1;
const noop = () => {};
const defaultState = {
  downloadWarningModal: false,
  downloadConfirmModal: false,
  confirmState: {
    firstWarning: false,
    secondWarning: false,
    thirdWarning: false,
  },
};

const DownloadData = ({
  isTimezoneIncluded = false,
  isDownloadingData = false,
  onChange = noop,
  onDownloadConfirm = noop,
  extensionType = 'Limited',
  disabled = false,
  syncProgress = null,
}) => {
  const [state, setState] = React.useState(defaultState);

  const handleChange = event => {
    const name = event.currentTarget.name;
    setState(prevState => ({
      ...prevState,
      confirmState: {
        ...prevState.confirmState,
        [name]: !prevState.confirmState[name],
      },
    }));
  };

  const handleDownloadConfirm = async () => {
    if (!syncProgress) {
      await onDownloadConfirm();
      setState(defaultState);
    }
  };

  React.useEffect(() => {
    if (syncProgress) {
      setState(defaultState);
    }
  }, [syncProgress]);

  //JSX
  return (
    <>
      <Paper
        className={clsx('p-6 mr-10 ml-10 mt-5')}
        elevation={paperElevation}
      >
        <div className='d-flex f-justify-between'>
          <div>
            <Typography variant='body1' className='bold-font'>
              Instructions
            </Typography>
            <Typography variant='body2'>
              1. Select Limited Extensions or User Extensions above <br />
              2. Download the Excel File <br />
              3. Edit the information for the extensions you wish to change.
              Delete any row(s) that you do NOT want to update, but do not
              delete columns. <br />
              ** The API will not accept emails set to [.comX]. To continue
              using dummy emails, change them to [X.com]
            </Typography>
            <div className='d-flex'>
              <Checkbox
                name='isTimezoneIncluded'
                color='primary'
                size='small'
                checked={isTimezoneIncluded}
                disabled={disabled}
                onChange={event => {
                  onChange(event.target.checked);
                }}
              />
              <Typography variant='body2' className='mt-2'>
                Include Timezone
              </Typography>
            </div>
          </div>
          <div>
            <Button
              variant='contained'
              color='primary'
              className='bold-font'
              startIcon={<SystemUpdateAltIcon />}
              disabled={disabled}
              onClick={() => {
                setState(prevState => ({
                  ...prevState,
                  downloadWarningModal: true,
                }));
              }}
            >
              Download
            </Button>
          </div>
        </div>
      </Paper>
      <DownloadWarning
        isOpen={state.downloadWarningModal}
        onClose={() => {
          setState(defaultState);
        }}
        onConfirm={() => {
          setState(prevState => ({
            ...prevState,
            downloadWarningModal: false,
            downloadConfirmModal: true,
          }));
        }}
      />
      <DownLoadConfirm
        extensionType={extensionType}
        confirmState={state.confirmState}
        isOpen={state.downloadConfirmModal}
        isDownloadingData={isDownloadingData}
        onClose={() => {
          setState(prevState => ({
            ...prevState,
            confirmState: defaultState.confirmState,
            downloadConfirmModal: false,
          }));
        }}
        onDownloadConfirm={handleDownloadConfirm}
        handleChange={handleChange}
      />
    </>
  );
};
export default DownloadData;
